export default {
    loading: 'taskStatistic:loading',
    search: 'taskStatistic:search',
    statisticList: 'taskStatistic:list',
    agents: 'taskStatistic:agents',
    areas: 'taskStatistic:areas',
    statisticTotal: 'taskStatistic:total',
}


// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/task-statistics/constant.js